<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content">
			<div class="columns column6">
				<h2 v-if="page.subtitle" class="subtitle">
					{{ page.subtitle }}
				</h2>
				<h1>{{ page.title }}</h1>
				<div v-parse-links v-html="page.content" />
			</div>
			<div class="columns column6">
				<iframe
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2435.9361726229745!2d4.880666876970416!3d52.371577347207385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c609c7b5d6eacf%3A0x90a85be8567337ce!2sCaf%C3%A9%20Restaurant%20Verlan!5e0!3m2!1snl!2snl!4v1690882266900!5m2!1snl!2snl"
					width="100%"
					height="550"
					style="border: 0"
					allowfullscreen
					loading="lazy"
					referrerpolicy="no-referrer-when-downgrade"
				/>
			</div>
		</main-content>

		<!--
		<section class="content-section section-reservations">
			<div class="row">
				<div class="columns column6">
					<h3>{{ defaults[locale].website.restaurantName }}</h3>
					<div class="address">
						<p>
							<span> {{ defaults[locale].website.street }} {{ defaults[locale].website.number }} </span
							><br />
							<span>{{ defaults[locale].website.country }}</span
							><br />
							<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
								<span>{{ defaults[locale].website.phone }}</span> </a
							><br />
							<a :href="`mailto:${defaults[locale].website.email}`">
								<span>{{ defaults[locale].website.email }}</span>
							</a>
						</p>
					</div>
				</div>
				<div class="columns column6">
					<div class="form-wrapper">
						<contact-form name="contact" :form="form" />
					</div>
				</div>
			</div>
		</section>
		-->

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();

await fetchPage();

onMounted(() => {
	if (window.FT) {
		window.FT.widgets.current.parse();
	}
});

if (!defaults.value) {
	await fetchDefaults();
}

// const { data: form } = await useWebsiteFetch('contact', {
// 	query: { language: locale.value },
// 	key: `${locale.value}/contact`,
// });
</script>

<style lang="scss" scoped>
#maps {
	min-height: 600px;
}

.form-wrapper {
	padding: 40px 30px;
	background: var(--secondary-background-color);
}
</style>
